<template>
    <div class="progess">
         <!-- 左侧竖线 -->
         <div class="left_s"></div>
         <!-- 左侧内容 -->
         <div class="txt left_p">{{min}}分</div>
         <div class="txt left_p_b">{{maxNum}}</div>
         <!-- 30-100分五块 -->
         <div class="wid one"></div>
         <div class="wid two mg_l"></div>
         <div class="wid the mg_l"></div>
         <div class="wid for mg_l"></div>
         <div class="wid fiv mg_l"></div>
         <!-- 右侧竖线 -->
         <div class="right_s"></div>
         <!-- 右侧内容 -->
         <div class="txt right_p">{{max}}分</div>
         <div class="txt right_p_b">{{minNum}}</div>
         <!-- 三角 -->
         <div :id="id" class="btm_p">
             <div class="num_txt">{{num}}<span class="num_txt_s">分</span></div>
             <div class="sj"></div>
             <div class="txt_center">{{carbonNum}}</div>
         </div>
    </div>
 </template>
 
 <script>
 import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
 import { useRoute, useRouter } from 'vue-router';
 export default {
     name: 'progess',
     props:{
         name:{
             type:String,
             default:() => null
         },
         num:{
             type:Number,
             default:() => 30
         },
         carbonNum:{
             type:String,
             default:() => 'xxx'
         },
         maxNum:{
             type:String,
             default:() => 'xxx'
         },
         minNum:{
             type:String,
             default:() => 'xxx'
         },
         max:{
             type:Number,
             default:() => 100
         },
         min:{
             type:Number,
             default:() => 30
         }
     },
     setup(props) {
         const data = reactive({
             num:props.num,
             id:props.name,
             maxNum:props.maxNum,
             minNum:props.minNum,
             carbonNum:props.carbonNum,
             max:props.max,
             min:props.min
         })
         // 改变进度条位置
         const changeProgess = () => {
             const progess = document.getElementById(data.id)
             
             if(data.num <= 30){
                 progess.style.left = '3px'
                 progess.childNodes[0].style.textAlign = 'left'
                 progess.childNodes[1].style.left = '0px'
                 progess.childNodes[2].style.textAlign = 'left'
             }else if(data.num >= 100){
                 progess.style.right = '3px'
                 progess.childNodes[0].style.textAlign = 'right'
                 progess.childNodes[1].style.right = '0px'
                 progess.childNodes[2].style.textAlign = 'right'
             }else if(data.num >= 50){
                 progess.style.left = data.num - 20+'%'
                 progess.childNodes[0].style.textAlign = 'right'
                 progess.childNodes[1].style.left = data.num - 20 +'%'
                 progess.childNodes[2].style.textAlign = 'right'
             }else if(data.num < 50){
                 progess.style.left = data.num - 30 +'%'
                 progess.childNodes[0].style.textAlign = 'left'
                 progess.childNodes[1].style.left = data.num - 30 +'%'
                 progess.childNodes[2].style.textAlign = 'left'
             }else{
                 progess.style.left = '0px'
                 progess.childNodes[0].style.textAlign = 'left'
                 progess.childNodes[1].style.left = '0px'
                 progess.childNodes[2].style.textAlign = 'left'
             }
         }
         onBeforeMount(() => {
             
         })
         onMounted(() => {
             changeProgess()
         })
         return {
             ...toRefs(data),
         }
     },
 }
 
 </script>
 <style scoped lang='less'>
 .progess{
     width: 100%;
     display: flex;
     align-items: center;
     position: relative;
     .left_s{
         width: 3px;
         height: 114px;
         background: #FF7334;
     }
     .right_s{
         width: 3px;
         height: 114px;
         background: #013C89;
     }
     .wid{
         width: 130px;
         height: 14px;
     }
     .one{
         background: #FF7334;
     }
     .two{
         background: #F3B000;
     }
     .the{
         background: #B0D900;
     }
     .for{
         background: #00BAF4;
     }
     .fiv{
         background: #013C89;
     }
     .txt{
         font-size: 14px;
         font-weight: 400;
         color: #333333;
         line-height: 28px;
     }
     .txt_c{
         color: #00BAF4;
     }
     .left_p{
         position: absolute;
         left: 0;
         top: -30px;
     }
     .left_p_b{
         position: absolute;
         left: 0;
         bottom: -30px;
     }
     .right_p{
         position: absolute;
         right: 0;
         top: -30px;
     }
     .right_p_b{
         position: absolute;
         right: 0;
         bottom: -30px;
     }
     .mg_l{
         margin-left: 4px;
     }
     .sj{
         margin-right: 3px;
         position: absolute;
         top: 50px;
         width: 0;
         height: 0;
         border-left: 5.5px solid transparent;
         border-right: 5.5px solid transparent;
         border-bottom: 11px solid #00BAF4;
     }
     .btm_p{
         position: absolute;
         .num_txt{
             margin-bottom: 30px;
             // text-align: center;
             font-size: 32px;
             font-weight: 500;
             color: #00BAF4;
             line-height: 32px;
         }
         .num_txt_s{
             font-size: 24px;
             font-family: PingFangSC-Medium, PingFang SC;
             font-weight: 500;
             color: #00BAF4;
             line-height: 25px;
         }
         .txt_center{
             // text-align: center;
             font-size: 14px;
             font-weight: 500;
             color: #00BAF4;
             // line-height: 38px;
         }
         .mg_t{
             margin-bottom: 50px;
         }
     }
 }
 </style>